import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminNextPage } from './admin-next';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    AdminNextPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminNextPage),PipesModule
  ],
  entryComponents: [
    AdminNextPage
  ]
})
export class AdminNextPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-next/admin-next.module.ts